module.exports = __webpack_public_path__ + "static/img/1.7cd27e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhongzaisheng/detail1/1.png
// module id = CL7b
// module chunks = 19